import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../../../../../context/AppContext";
import { Link, useNavigate } from "react-router-dom";
import AuthPageLayout from "../../../../components/AuthPageLayout";
import ButtonLoader from "../../../../../../components/ButtonLoader";
import Transition from "../../../../../../components/Transition";
import { GenerateOTP } from "../../../../network/api/GenerateOTP";
import { AnimatePresence } from "framer-motion";


export default function Register() {
    const { appData } = useAppContext();
    const navigate = useNavigate();
    const { referrer } = useParams();

    const [formData, setFormData] = useState({
        name: "",
        displayname: "",
        email: "",
        phone: "",
        password: "",
        terms: false,
        app_id: appData.id,
        referrer: referrer || null,
    });

    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        setErrorMessage("");
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });

        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();

        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = "Full Name is required";
        if (!formData.displayname.trim()) newErrors.displayname = "Display Name is required";
        if (!formData.email.trim()) newErrors.email = "Email is required";
        if (!formData.phone.trim()) newErrors.phone = "Contact number is required";
        if (!formData.password.trim()) newErrors.password = "Password is required";
        if (!formData.terms) newErrors.terms = "You must agree to the terms";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsLoading(false);
            return;
        }

        const response = await GenerateOTP({ email: formData.email, app_id: appData.id, });

        if (response.status === "success" && response.data) {
            setIsLoading(false);
            navigate("/register/email-verification", { state: { formData: formData, realOtp: response.data.otp } })
            //console.log(response.data)

        } else {
            setIsLoading(false);
            setErrorMessage(response.message);

        }

    };

    return (
        <AuthPageLayout>
            <h4 className="text-center mb-4">Sign up your {appData.name} account</h4>
            {!isLoading && errorMessage ? (
                <AnimatePresence mode="wait">
                    <Transition key={errorMessage} >
                        <div className="alert alert-danger alert-dismissible alert-alt solid fade show">
                            <strong>Error!</strong> {errorMessage}
                        </div>
                    </Transition>
                </AnimatePresence>
            ) : null}
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="mb-1"><strong>Full Name</strong></label>
                    <input
                        type="text"
                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                        placeholder="Peace TheeCoder"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                </div>

                <div className="mb-3">
                    <label className="mb-1"><strong>Display Name</strong></label>
                    <input
                        type="text"
                        className={`form-control ${errors.displayname ? "is-invalid" : ""}`}
                        placeholder="Today Forex Trader"
                        name="displayname"
                        value={formData.displayname}
                        onChange={handleChange}
                    />
                    {errors.displayname && <div className="invalid-feedback">{errors.displayname}</div>}
                </div>

                <div className="mb-3">
                    <label className="mb-1"><strong>Email</strong></label>
                    <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        placeholder="admin@example.com"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>

                <div className="mb-3">
                    <label className="mb-1"><strong>Contact</strong></label>
                    <input
                        type="text"
                        className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                        placeholder="+2771 234 5678"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                    />
                    {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                </div>

                <div className="mb-3 position-relative">
                    <label className="mb-1"><strong>Password</strong></label>
                    <input
                        type="password"
                        id="dz-password"
                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                        placeholder="********"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                    />
                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    <span className="show-pass eye">
                        <i className="fa fa-eye-slash"></i>
                        <i className="fa fa-eye"></i>
                    </span>
                </div>

                <div className="mb-3">
                    <div className="form-check custom-checkbox ms-1">
                        <input
                            type="checkbox"
                            className={`form-check-input ${errors.terms ? "is-invalid" : ""}`}
                            id="basic_checkbox_1"
                            name="terms"
                            checked={formData.terms}
                            onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="basic_checkbox_1">
                            I have read and I agree to all the{" "}
                            <Link className="link-primary" to="/terms" target="_blank">
                                terms and conditions
                            </Link>{" "}
                            of using {appData.name}.
                        </label>
                        {errors.terms && <div className="invalid-feedback d-block">{errors.terms}</div>}
                    </div>
                </div>

                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
                        {isLoading ? <ButtonLoader /> : "Sign up"}
                    </button>
                </div>
            </form>

            <div className="new-account mt-3">
                <p>Already have an account? <Link className="text-primary" to="/login">Sign in</Link></p>
            </div>


        </AuthPageLayout>

    );
}